namespace $ {
	export class $shm_hitalama_guide_catalog extends $giper_baza_entity.with({
		Pages: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_guide_document ) ),
		Groups: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_guide_group ) ),
		Orders: $giper_baza_dict_to( $giper_baza_atom_list ),
		Sections: $giper_baza_dict_to( $giper_baza_atom_text ),
		Github_repository: $giper_baza_atom_text,
	}) {
		@ $mol_mem
		static current() {
			const domain = this.$.$shm_hitalama_domain.instance()
			this.$.$shm_hitalama_map_component_ready.read( domain )
			const source = domain.Guide_catalog()
			if( source ) this.$.$shm_hitalama_map_component_ready.read( source )
			return source?.remote() ?? null
		}
		static allocate( domain: string ) { return this.$.$giper_baza_glob.land_grab( [[ null, this.$.$giper_baza_rank_read ]] ).Data( this ) }
		@ $mol_action
		static ensure() {
			const domain = this.$.$shm_hitalama_domain.instance()
			// Partial root metadata is enough for display, but not proof of absence.
			this.$.$shm_hitalama_map_history_storage_ready.settled( domain )
			const previous = this.current()
			if( previous ) return previous
			if( !domain.can_change() ) throw new Error( 'Руководство не настроено. Обратитесь к администратору.' )
			const catalog = $mol_wire_sync( this ).allocate( domain.link().str )
			const arrived = this.current()
			if( arrived ) return arrived
			domain.Guide_catalog( null )!.remote( catalog )
			return catalog
		}
		static slug( id: string ) {
			if( !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test( id ) || id.length > 80 || /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/.test( id ) ) throw new Error( 'ID страницы: строчные латинские буквы, цифры и дефисы, до 80 символов.' )
			return id
		}
		@ $mol_action
		seed_initial() { this.$.$shm_hitalama_guide_seed.apply( this ) }
		ids() { this.$.$shm_hitalama_map_component_ready.read( this ); return ( this.Pages()?.keys().map( String ) ?? [] ).filter( id => this.Pages()?.key( id )?.remote() ).sort() }
		page( id: string ) { this.$.$shm_hitalama_map_component_ready.read( this ); return this.Pages()?.key( id )?.remote() ?? null }
		root( section: string ) { this.$.$shm_hitalama_map_component_ready.read( this ); return this.Sections()?.key( section )?.val() || 'start' }
		private drafts = new WeakMap<object, $shm_hitalama_guide_document>()
		draft( operation: object ) {
			let page = this.drafts.get( operation )
			if( !page ) { page = this.land().area_make().Data( this.$.$shm_hitalama_guide_document ); this.drafts.set( operation, page ) }
			return page
		}
		@ $mol_action
		create( operation: object, id: string, snapshot: string ) {
			this.$.$shm_hitalama_guide_catalog.slug( id )
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение руководства.' )
			if( this.group( id ) ) throw new Error( 'Этот ID уже занят группой.' )
			this.validate_parent( id, JSON.parse( snapshot ).parent ?? '' )
			const previous = this.page( id )
			if( previous && previous !== this.drafts.get( operation ) ) throw new Error( 'Страница с таким ID уже существует.' )
			const page = $mol_wire_sync( this ).draft( operation )
			if( previous === page ) return page
			$mol_wire_sync( page ).write( snapshot, '' )
			this.Pages( null )!.key( id, null )!.remote( page )
			return page
		}
		validate_links( links: {page: string, title: string}[] ) {
			for( const link of links ) if( !this.page( link.page ) ) throw new Error( 'Не найдена страница ссылки: ' + link.page )
		}
		groups() { this.$.$shm_hitalama_map_component_ready.read( this ); return ( this.Groups()?.keys().map( String ) ?? [] ).filter( id => this.group( id ) ) }
		group( id: string ) {
			this.$.$shm_hitalama_map_component_ready.read( this )
			const group = this.Groups()?.key( id )?.remote() ?? null
			if( group ) this.$.$shm_hitalama_map_component_ready.read( group )
			return group
		}
		folder_options() { return { '': 'Без группы', ...Object.fromEntries( this.groups().map( id => [ id, this.group_path( id ) ] ) ) } }
		group_path( id: string ) {
			const titles: string[] = [], seen = new Set<string>()
			for( let cursor = id; cursor && !seen.has( cursor ); cursor = this.group( cursor )?.Parent()?.val() ?? '' ) { seen.add( cursor ); titles.unshift( this.group( cursor )?.title() ?? cursor ) }
			return titles.join( ' / ' )
		}
		validate_parent( id: string, parent: string ) {
			if( !parent ) return
			if( !this.group( parent ) ) throw new Error( 'Группа не найдена.' )
			const seen = new Set([id])
			for( let cursor = parent; cursor; cursor = this.group( cursor )?.Parent()?.val() ?? '' ) { if( seen.has( cursor ) ) throw new Error( 'Нельзя вложить группу в саму себя.' ); seen.add( cursor ) }
		}
		private group_drafts = new WeakMap<object, $shm_hitalama_guide_group>()
		group_draft( operation: object ) { let group = this.group_drafts.get( operation ); if( !group ) { group = this.land().area_make().Data( this.$.$shm_hitalama_guide_group ); this.group_drafts.set( operation, group ) }; return group }
		@ $mol_action
		group_create( operation: object, id: string, title: string, parent: string ) {
			this.$.$shm_hitalama_guide_catalog.slug( id ); this.validate_parent( id, parent )
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение руководства.' )
			if( !title.trim() || this.page( id ) ) throw new Error( 'Укажите название и свободный ID группы.' )
			const previous = this.group( id )
			if( previous && previous !== this.group_drafts.get( operation ) ) throw new Error( 'Такой ID группы уже существует.' )
			const group = $mol_wire_sync( this ).group_draft( operation )
			if( previous === group ) return group
			group.title( title.trim() ); group.Parent( null )!.val( parent )
			this.Groups( null )!.key( id, null )!.remote( group )
			return group
		}
		@ $mol_action
		group_update( id: string, title: string, parent: string ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение руководства.' )
			this.validate_parent( id, parent )
			if( !title.trim() ) throw new Error( 'Укажите название группы.' )
			const group = this.group( id )
			if( !group ) throw new Error( 'Группа не найдена.' )
			group.title( title.trim() ); group.Parent( null )!.val( parent )
		}
		/** Discover all known page files before a cold read suspends on the first one. */
		files_ready() {
			return this.ids().map(id=>{
				const page=this.page(id),file=page?.File()?.remote(),chunks=file?.Chunks()
				return !!(file?.units().length&&chunks?.units().length)
			}).every(Boolean)
		}
		tree() {
			this.files_ready()
			const groups = this.groups(), ids = this.ids(), group_set = new Set( groups ), nodes = new Map<string, string[]>( [ ['', []], ...groups.map( id => [id, []] as [string,string[]] ) ] )
			const parent_of = ( id: string )=> group_set.has( id ) ? this.group( id )?.Parent()?.val() ?? '' : this.page( id )!.parent()
			for( const id of [ ...groups, ...ids ] ) {
				let parent = parent_of( id ); const seen = new Set([id])
				for( let cursor = parent; cursor; cursor = parent_of( cursor ) ) { if( !group_set.has( cursor ) || seen.has( cursor ) ) { parent = ''; break }; seen.add( cursor ) }
				if( !nodes.has( parent ) ) parent = ''
				nodes.get( parent )!.push( id )
			}
			const title = ( id: string )=> group_set.has( id ) ? this.group( id )!.title() : this.page( id )!.read().title
			for( const [parent,children] of nodes ) { const order=this.Orders()?.key(parent||'/root')?.val() ?? [], ranks=new Map(order.map((id,index)=>[String(id),index]));children.sort( (a,b)=> (ranks.get(a)??order.length)-(ranks.get(b)??order.length) || Number(group_set.has(b))-Number(group_set.has(a)) || title(a).localeCompare(title(b),'ru') ) }
			return nodes
		}
		@ $mol_action
		node_move( id: string, parent: string, siblings: readonly string[] ) {
			if(!this.can_change())throw new Error('Нет прав на изменение руководства.')
			this.validate_parent(id,parent)
			const group=this.group(id),page=this.page(id);if(!group&&!page)throw new Error('Элемент не найден.')
			const expected=[...(this.tree().get(parent)??[]).filter(child=>child!==id),id]
			if(siblings.length!==expected.length||new Set(siblings).size!==expected.length||expected.some(child=>!siblings.includes(child)))throw new Error('Список руководства изменился. Повторите перенос.')
			if(group)group.Parent(null)!.val(parent);else page!.parent(parent)
			this.Orders(null)!.key(parent||'/root',null)!.val([...siblings])
		}
		group_removal( id: string ) {
			if(!this.can_change())throw new Error('Нет прав на изменение руководства.')
			const group=this.group(id);if(!group)return null
			const tree=this.tree(),parent=[...tree].find(([,children])=>children.includes(id))?.[0]??'',children=tree.get(id)??[],siblings=(tree.get(parent)??[]).flatMap(child=>child===id?children:[child])
			const groups=children.map(child=>this.group(child)).filter((group): group is $shm_hitalama_guide_group=>!!group),pages=children.filter(child=>!this.group(child)).map(child=>this.page(child)!)
			return {parent,siblings,groups,pages}
		}
		@ $mol_action
		group_remove( id: string ) {
			const plan=$mol_wire_sync(this).group_removal(id);if(!plan)return
			for(const group of plan.groups)group.Parent(null)!.val(plan.parent)
			for(const page of plan.pages)page.parent(plan.parent)
			this.Orders(null)!.key(plan.parent||'/root',null)!.val(plan.siblings)
			this.Groups()?.key(id,null)?.remote(null)
		}
		@ $mol_action
		remove( id: string ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение руководства.' )
			for( const key of this.Sections()?.keys() ?? [] ) if( this.Sections()?.key( key )?.val() === id ) throw new Error( 'Сначала назначьте другую начальную страницу раздела.' )
			for( const key of this.ids() ) if( key !== id && this.$.$shm_hitalama_guide_markdown.references(this.$.$shm_hitalama_guide_markdown.text(this.page(key)!.read())).includes(id) ) throw new Error( 'Сначала удалите ссылки на эту страницу: ' + key )
			this.Pages()?.key( id, null )?.remote( null )
		}
	}
}
